export type TAdminUsersListParams = {
  page: number;
  pageSize: number;
  orderBy: string;
  orderType: 'asc' | 'desc';
  search: string;
};

export const adminUsersKeys = {
  all: [{ module: 'adminUsers' }] as const,
  lists: () => [{ ...adminUsersKeys.all[0], scope: 'list' }] as const,
  list: (params: TAdminUsersListParams) => [{ ...adminUsersKeys.lists()[0], params }] as const,
  details: () => [{ ...adminUsersKeys.all[0], scope: 'detail' }] as const,
  detail: (userId: string) => [{ ...adminUsersKeys.details()[0], userId }] as const,
};
